import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-888e2968"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "overlay"
}
const _hoisted_2 = { style: {"height":"90vh"} }
const _hoisted_3 = { style: {"height":"0.5vh","background-color":"#ccc"} }
const _hoisted_4 = { class: "p-mt-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"20px"},
  class: "pi pi-globe"
}, null, -1))
const _hoisted_6 = { class: "p-mx-1" }
const _hoisted_7 = { class: "p-mx-1" }
const _hoisted_8 = { class: "p-mx-1" }
const _hoisted_9 = { class: "p-mx-1" }
const _hoisted_10 = { class: "p-mx-1" }
const _hoisted_11 = {
  class: "p-col-12",
  style: {"height":"8vh"}
}
const _hoisted_12 = { class: "p-grid" }
const _hoisted_13 = { class: "p-col-9 p-pr-0" }
const _hoisted_14 = { class: "p-fluid" }
const _hoisted_15 = { class: "p-mr-1" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" NAME : ")
const _hoisted_17 = { class: "pull-right" }
const _hoisted_18 = { class: "p-mr-1" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" REF : ")
const _hoisted_20 = { class: "pull-right" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" GENERIC : ")
const _hoisted_22 = { class: "pull-right" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" BATCHES : ")
const _hoisted_24 = { class: "pull-right" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Total Units : ")
const _hoisted_26 = { class: "pull-right" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Minimum Stock Units : ")
const _hoisted_28 = { class: "pull-right" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Brand Name : ")
const _hoisted_30 = { class: "pull-right" }
const _hoisted_31 = { class: "p-col-3" }
const _hoisted_32 = { class: "p-fluid" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" NAME : ")
const _hoisted_34 = { class: "pull-right" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Email : ")
const _hoisted_36 = { class: "pull-right" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Contact : ")
const _hoisted_38 = { class: "pull-right" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Account Type : ")
const _hoisted_40 = { class: "pull-right" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { class: "p-error" }
const _hoisted_43 = {
  key: 1,
  class: "p-error"
}
const _hoisted_44 = {
  class: "p-col-12 pos-table",
  style: {"height":"64vh","background-color":"#f9f9f9"}
}
const _hoisted_45 = { class: "table table-stiped table-bordered p-m-0" }
const _hoisted_46 = { class: "pos-heading" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"8rem"} }, "Product Name", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"8rem"} }, "Batch No", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Barcode", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Unit Qty", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Free Qty (Unit)", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Sup Bonus (Unit)", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Unit Disc (%)", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "After Disc", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Cus Disc %", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Expiry Date", -1))
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { key: 1 }
const _hoisted_59 = { key: 2 }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "REMOVE", -1))
const _hoisted_61 = { class: "table-row" }
const _hoisted_62 = { class: "p-inputgroup" }
const _hoisted_63 = { class: "p-inputgroup" }
const _hoisted_64 = { class: "p-inputgroup" }
const _hoisted_65 = { class: "p-inputgroup" }
const _hoisted_66 = { class: "p-inputgroup" }
const _hoisted_67 = { class: "p-inputgroup" }
const _hoisted_68 = { class: "p-inputgroup" }
const _hoisted_69 = { class: "p-inputgroup" }
const _hoisted_70 = { class: "p-inputgroup" }
const _hoisted_71 = { class: "p-inputgroup" }
const _hoisted_72 = { class: "p-inputgroup" }
const _hoisted_73 = { class: "p-inputgroup" }
const _hoisted_74 = { key: 0 }
const _hoisted_75 = { class: "p-inputgroup" }
const _hoisted_76 = { key: 1 }
const _hoisted_77 = { class: "p-inputgroup" }
const _hoisted_78 = { key: 2 }
const _hoisted_79 = { class: "p-inputgroup" }
const _hoisted_80 = { class: "p-text-center" }
const _hoisted_81 = { class: "p-text-center" }
const _hoisted_82 = {
  key: 0,
  class: "item-detail-row"
}
const _hoisted_83 = ["colspan"]
const _hoisted_84 = { class: "p-mr-1" }
const _hoisted_85 = /*#__PURE__*/_createTextVNode(" PRODUCT NAME: ")
const _hoisted_86 = { class: "heighlighted-green" }
const _hoisted_87 = { class: "p-mr-1" }
const _hoisted_88 = /*#__PURE__*/_createTextVNode(" GENERIC: ")
const _hoisted_89 = { class: "heighlighted-green" }
const _hoisted_90 = { class: "p-mx-1" }
const _hoisted_91 = /*#__PURE__*/_createTextVNode(" TOTAL UNITS : ")
const _hoisted_92 = { class: "heighlighted-green" }
const _hoisted_93 = { class: "p-mx-1" }
const _hoisted_94 = /*#__PURE__*/_createTextVNode(" UNIT PRICE(MRP) : ")
const _hoisted_95 = { class: "heighlighted-green" }
const _hoisted_96 = { class: "p-mx-1" }
const _hoisted_97 = /*#__PURE__*/_createTextVNode(" Minimum Stock Units : ")
const _hoisted_98 = { class: "heighlighted-green" }
const _hoisted_99 = {
  class: "p-col-12",
  style: {"height":"10vh","background-color":"#eee"}
}
const _hoisted_100 = { class: "p-grid" }
const _hoisted_101 = { class: "p-col-9 p-pr-0" }
const _hoisted_102 = { class: "p-fluid" }
const _hoisted_103 = { class: "p-col-3" }
const _hoisted_104 = { class: "p-fluid" }
const _hoisted_105 = {
  style: {"height":"10vh"},
  class: "p-grid p-m-0 p-p-0"
}
const _hoisted_106 = { class: "set-bottom-amt p-col" }
const _hoisted_107 = /*#__PURE__*/_createTextVNode("Total QTY ")
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_109 = { class: "set-bottom-amt p-col" }
const _hoisted_110 = /*#__PURE__*/_createTextVNode("Total Gross ")
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_112 = { class: "set-bottom-amt p-col" }
const _hoisted_113 = /*#__PURE__*/_createTextVNode("Total Disc ")
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_115 = {
  key: 0,
  class: "set-bottom-amt p-col"
}
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_117 = {
  key: 1,
  class: "set-bottom-amt p-col"
}
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_119 = {
  key: 2,
  class: "set-bottom-amt p-col"
}
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_121 = { class: "set-bottom-amt p-col" }
const _hoisted_122 = /*#__PURE__*/_createTextVNode("Net Total ")
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_124 = { class: "confirmation-content" }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-search p-mr-3",
  style: {"font-size":"2rem"}
}, null, -1))
const _hoisted_126 = { class: "p-fluid" }
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "search_receipt" }, " Enter Receipt No ", -1))
const _hoisted_128 = { class: "confirmation-content" }
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle p-mr-3",
  style: {"font-size":"2rem"}
}, null, -1))
const _hoisted_130 = { class: "confirmation-content" }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle p-mr-3",
  style: {"font-size":"2rem","color":"red"}
}, null, -1))
const _hoisted_132 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_PaymentScreen = _resolveComponent("PaymentScreen")!
  const _component_FileUploader = _resolveComponent("FileUploader")!
  const _component_ProfilerDialog = _resolveComponent("ProfilerDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.progressBar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.progressBar)
            ? (_openBlock(), _createBlock(_component_ProgressBar, {
                key: 0,
                mode: "indeterminate",
                style: {"height":"0.2em"}
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_Toolbar, { style: {"height":"7.5vh"} }, {
          start: _withCtx(() => [
            _createElementVNode("h5", _hoisted_4, [
              _createElementVNode("b", null, [
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(_ctx.storeName), 1)
              ])
            ])
          ]),
          end: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_Dropdown, {
                style: {"width":"15rem"},
                modelValue: _ctx.item.type,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.item.type) = $event)),
                options: _ctx.modeList,
                optionLabel: "label",
                optionValue: "value",
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.shiftPos()))
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_Button, {
                icon: "pi pi-download",
                label: "Download Sample CSV",
                class: "p-button-warning",
                onClick: _ctx.downloadSample
              }, null, 8, ["onClick"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_Button, {
                icon: "pi pi-upload",
                label: "Upload CSV",
                class: "p-button-primary",
                onClick: _ctx.openFileUploader
              }, null, 8, ["onClick"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_Button, {
                icon: "pi pi-plus",
                label: "New Supplier",
                class: "p-button-success",
                onClick: _ctx.openProfileDialog
              }, null, 8, ["onClick"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_Button, {
                icon: "pi pi-times",
                label: "Clear Screen",
                class: "p-button-danger",
                onClick: _ctx.clearAll
              }, null, 8, ["onClick"])
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_AutoComplete, {
                  delay: 1000,
                  minLength: 3,
                  onItemSelect: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveItem($event))),
                  scrollHeight: "500px",
                  modelValue: _ctx.itemScanBox,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.itemScanBox) = $event)),
                  suggestions: _ctx.itemList,
                  placeholder: " SCAN BARCODE OR SEARCH ITEMS",
                  onComplete: _cache[4] || (_cache[4] = ($event: any) => (_ctx.searchItem($event))),
                  dropdown: false,
                  autoFocus: ""
                }, {
                  item: _withCtx((slotProps) => [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_15, [
                        _hoisted_16,
                        _createElementVNode("b", _hoisted_17, _toDisplayString(slotProps.item.product_name.toUpperCase()), 1)
                      ]),
                      _withDirectives(_createElementVNode("span", _hoisted_18, [
                        _hoisted_19,
                        _createElementVNode("b", _hoisted_20, _toDisplayString(slotProps.item.reference), 1)
                      ], 512), [
                        [_vShow, slotProps.item.reference]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("span", null, [
                        _hoisted_21,
                        _createElementVNode("b", _hoisted_22, _toDisplayString(slotProps.item.generic_name.toUpperCase()), 1)
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("small", null, [
                        _hoisted_23,
                        _createElementVNode("b", _hoisted_24, _toDisplayString(slotProps.item.batch_count), 1)
                      ]),
                      _createElementVNode("small", null, [
                        _hoisted_25,
                        _createElementVNode("b", _hoisted_26, _toDisplayString((slotProps.item.qty)? Number(slotProps.item.qty).toFixed(0):0), 1)
                      ]),
                      _createElementVNode("small", null, [
                        _hoisted_27,
                        _createElementVNode("b", _hoisted_28, _toDisplayString((slotProps.item.min_stock_qty)?Number(slotProps.item.min_stock_qty).toFixed(0) : 0), 1)
                      ]),
                      _createElementVNode("small", null, [
                        _hoisted_29,
                        _createElementVNode("b", _hoisted_30, _toDisplayString(slotProps.item.bName), 1)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "suggestions"])
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_AutoComplete, {
                  delay: 1000,
                  minLength: 3,
                  onItemSelect: _cache[5] || (_cache[5] = ($event: any) => (_ctx.saveProfile($event))),
                  scrollHeight: "500px",
                  modelValue: _ctx.v$.selectedProfile.$model,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.v$.selectedProfile.$model) = $event)),
                  suggestions: _ctx.profilerList,
                  placeholder: "Search Profile",
                  onComplete: _cache[7] || (_cache[7] = ($event: any) => (_ctx.searchProfiler($event))),
                  dropdown: false,
                  autoFocus: "",
                  class: _normalizeClass({'is-invalid': this.state.savedItemList.length > 0 && !_ctx.v$.selectedProfile.$model})
                }, {
                  item: _withCtx((slotProps) => [
                    _createElementVNode("div", null, [
                      _hoisted_33,
                      _createElementVNode("b", _hoisted_34, _toDisplayString(slotProps.item.account_title.toUpperCase()), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_35,
                      _createElementVNode("span", _hoisted_36, _toDisplayString(slotProps.item.email_address), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_37,
                      _createElementVNode("span", _hoisted_38, _toDisplayString(slotProps.item.contact_no), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_39,
                      _createElementVNode("span", _hoisted_40, _toDisplayString(slotProps.item.account_type), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "suggestions", "class"]),
                (_ctx.v$.selectedProfile.$error && _ctx.submitted)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_41, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.selectedProfile.$errors, (error, index) => {
                        return (_openBlock(), _createElementBlock("span", {
                          id: "p-error",
                          key: index
                        }, [
                          _createElementVNode("small", _hoisted_42, _toDisplayString(error.$message), 1)
                        ]))
                      }), 128))
                    ]))
                  : (
                      (_ctx.v$.selectedProfile.$invalid && _ctx.submitted) ||
                      _ctx.v$.selectedProfile.$pending.$response
                    )
                    ? (_openBlock(), _createElementBlock("small", _hoisted_43, _toDisplayString(_ctx.v$.selectedProfile.required.$message.replace(
                        "Value",
                        "Profile"
                      )), 1))
                    : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("table", _hoisted_45, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_46, [
                _hoisted_47,
                _hoisted_48,
                _hoisted_49,
                _hoisted_50,
                _hoisted_51,
                _hoisted_52,
                _createElementVNode("th", null, "Unit Purchase Price (" + _toDisplayString(_ctx.currency) + ")", 1),
                _hoisted_53,
                _hoisted_54,
                _createElementVNode("th", null, "MRP (" + _toDisplayString(_ctx.currency) + ")", 1),
                _hoisted_55,
                _hoisted_56,
                (_ctx.taxNames[0].show)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_57, _toDisplayString(_ctx.taxNames[0].taxName) + " %", 1))
                  : _createCommentVNode("", true),
                (_ctx.taxNames[1].show)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_58, _toDisplayString(_ctx.taxNames[1].taxName) + " %", 1))
                  : _createCommentVNode("", true),
                (_ctx.taxNames[2].show)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_59, _toDisplayString(_ctx.taxNames[2].taxName) + " %", 1))
                  : _createCommentVNode("", true),
                _createElementVNode("th", null, "Subtotal (" + _toDisplayString(_ctx.currency) + ")", 1),
                _hoisted_60
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.state.savedItemList.slice().reverse(), (savedItem) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: savedItem.id
                }, [
                  _createElementVNode("tr", _hoisted_61, [
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_62, [
                        _createVNode(_component_InputText, {
                          style: {"height":"30px"},
                          modelValue: savedItem.productName,
                          "onUpdate:modelValue": ($event: any) => ((savedItem.productName) = $event),
                          class: "p-p-1",
                          disabled: true
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_63, [
                        _createVNode(_component_InputText, {
                          style: {"height":"30px"},
                          modelValue: savedItem.batchNo,
                          "onUpdate:modelValue": ($event: any) => ((savedItem.batchNo) = $event),
                          class: _normalizeClass(["p-p-0", {'is-invalid': !savedItem.batchNo}])
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "class"])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_64, [
                        _createVNode(_component_InputText, {
                          style: {"height":"30px"},
                          modelValue: savedItem.barcode,
                          "onUpdate:modelValue": ($event: any) => ((savedItem.barcode) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_65, [
                        _createVNode(_component_InputNumber, {
                          useGrouping: false,
                          style: {"width":"2rem","height":"30px"},
                          min: 1,
                          modelValue: savedItem.unit,
                          "onUpdate:modelValue": ($event: any) => ((savedItem.unit) = $event),
                          class: "p-p-0"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_66, [
                        _createVNode(_component_InputNumber, {
                          useGrouping: false,
                          style: {"width":"2rem","height":"30px"},
                          min: 0,
                          modelValue: savedItem.freeUnit,
                          "onUpdate:modelValue": ($event: any) => ((savedItem.freeUnit) = $event),
                          class: "p-p-0"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_67, [
                        _createVNode(_component_InputNumber, {
                          useGrouping: false,
                          style: {"width":"2rem","height":"30px"},
                          min: 0,
                          modelValue: savedItem.supplierBonus,
                          "onUpdate:modelValue": ($event: any) => ((savedItem.supplierBonus) = $event),
                          class: "p-p-0"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_68, [
                        _createVNode(_component_InputNumber, {
                          ref_for: true,
                          ref: "inputNumberRef",
                          style: {"width":"2rem","height":"30px","padding-left":"10px"},
                          min: 0.00,
                          minFractionDigits: 2,
                          maxFractionDigits: 2,
                          modelValue: savedItem.purchasePrice,
                          "onUpdate:modelValue": ($event: any) => ((savedItem.purchasePrice) = $event),
                          onKeydown: _ctx.handleInput,
                          class: _normalizeClass(["p-p-0", {'is-invalid': savedItem.purchasePrice <= 0}])
                        }, null, 8, ["min", "modelValue", "onUpdate:modelValue", "onKeydown", "class"])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_69, [
                        _createVNode(_component_InputNumber, {
                          useGrouping: false,
                          style: {"width":"2rem","height":"30px"},
                          minFractionDigits: 2,
                          maxFractionDigits: 2,
                          max: "100",
                          min: "0",
                          modelValue: savedItem.itemDisc,
                          "onUpdate:modelValue": ($event: any) => ((savedItem.itemDisc) = $event),
                          class: "p-p-0"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_70, [
                        _createVNode(_component_InputNumber, {
                          useGrouping: false,
                          style: {"width":"2rem","height":"30px"},
                          minFractionDigits: 2,
                          maxFractionDigits: 2,
                          modelValue: savedItem.purchaseAfterDisc,
                          "onUpdate:modelValue": ($event: any) => ((savedItem.purchaseAfterDisc) = $event),
                          disabled: true,
                          class: "p-p-0"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_71, [
                        _createVNode(_component_InputNumber, {
                          style: {"width":"2rem","height":"30px"},
                          min: 0,
                          minFractionDigits: 2,
                          maxFractionDigits: 2,
                          modelValue: savedItem.mrp,
                          "onUpdate:modelValue": ($event: any) => ((savedItem.mrp) = $event),
                          onKeydown: _ctx.handleInput,
                          class: _normalizeClass(["p-p-0", {'is-invalid': savedItem.mrp <= 0}])
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown", "class"])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_72, [
                        _createVNode(_component_InputNumber, {
                          useGrouping: false,
                          style: {"width":"2rem","height":"30px"},
                          minFractionDigits: 2,
                          maxFractionDigits: 2,
                          modelValue: savedItem.cusDisc,
                          "onUpdate:modelValue": ($event: any) => ((savedItem.cusDisc) = $event),
                          max: "100",
                          min: "0",
                          class: "p-p-0"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_73, [
                        _createVNode(_component_Calendar, {
                          id: "expiryDate",
                          modelValue: savedItem.expiryDate,
                          "onUpdate:modelValue": ($event: any) => ((savedItem.expiryDate) = $event),
                          style: {"width":"2rem","height":"30px"},
                          selectionMode: "single",
                          dateFormat: "dd-mm-yy",
                          manualInput: false,
                          minDate: _ctx.getDateAfterMonths(3),
                          maxDate: new Date(3000, 0, 1),
                          class: _normalizeClass({'is-invalid': (!savedItem.expiryDate && savedItem.expirable)})
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "minDate", "maxDate", "class"])
                      ])
                    ]),
                    (_ctx.taxNames[0].show)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_74, [
                          _createElementVNode("div", _hoisted_75, [
                            _createVNode(_component_InputNumber, {
                              useGrouping: false,
                              style: {"width":"2rem","height":"30px"},
                              minFractionDigits: 2,
                              maxFractionDigits: 2,
                              modelValue: savedItem.tax1,
                              "onUpdate:modelValue": ($event: any) => ((savedItem.tax1) = $event),
                              class: "p-p-0"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.taxNames[1].show)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_76, [
                          _createElementVNode("div", _hoisted_77, [
                            _createVNode(_component_InputNumber, {
                              useGrouping: false,
                              style: {"width":"2rem","height":"30px"},
                              minFractionDigits: 2,
                              maxFractionDigits: 2,
                              modelValue: savedItem.tax2,
                              "onUpdate:modelValue": ($event: any) => ((savedItem.tax2) = $event),
                              class: "p-p-0"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.taxNames[2].show)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_78, [
                          _createElementVNode("div", _hoisted_79, [
                            _createVNode(_component_InputNumber, {
                              useGrouping: false,
                              style: {"width":"2rem","height":"30px"},
                              minFractionDigits: 2,
                              maxFractionDigits: 2,
                              modelValue: savedItem.tax3,
                              "onUpdate:modelValue": ($event: any) => ((savedItem.tax3) = $event),
                              class: "p-p-0"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("td", _hoisted_80, [
                      _createElementVNode("b", null, _toDisplayString(_ctx.getTheSubtotal(savedItem)), 1)
                    ]),
                    _createElementVNode("td", _hoisted_81, [
                      _createVNode(_component_Button, {
                        icon: "pi pi-minus",
                        class: "p-button-danger p-p-1",
                        onClick: ($event: any) => (_ctx.clearListItem(savedItem))
                      }, null, 8, ["onClick"])
                    ])
                  ]),
                  (savedItem.productID != 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_82, [
                        _createElementVNode("td", { colspan: _ctx.countTaxesLen }, [
                          _createElementVNode("span", _hoisted_84, [
                            _hoisted_85,
                            _createElementVNode("span", _hoisted_86, _toDisplayString(_ctx.limitString(savedItem.productName)), 1)
                          ]),
                          _createElementVNode("span", _hoisted_87, [
                            _hoisted_88,
                            _createElementVNode("span", _hoisted_89, _toDisplayString(_ctx.limitString(savedItem.generic)), 1)
                          ]),
                          _createElementVNode("span", _hoisted_90, [
                            _hoisted_91,
                            _createElementVNode("span", _hoisted_92, _toDisplayString(Number(savedItem.totalUnit).toFixed(0)), 1)
                          ]),
                          _createElementVNode("span", _hoisted_93, [
                            _hoisted_94,
                            _createElementVNode("span", _hoisted_95, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(savedItem.sellingPrice)), 1)
                          ]),
                          _createElementVNode("span", _hoisted_96, [
                            _hoisted_97,
                            _createElementVNode("span", _hoisted_98, _toDisplayString(Number(savedItem.minStockQty).toFixed(0)), 1)
                          ])
                        ], 8, _hoisted_83)
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_99, [
          _createElementVNode("div", _hoisted_100, [
            _createElementVNode("div", _hoisted_101, [
              _createElementVNode("div", _hoisted_102, [
                _createVNode(_component_InputText, {
                  placeholder: "Receipt Description",
                  modelValue: _ctx.item.description,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.item.description) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_103, [
              _createElementVNode("div", _hoisted_104, [
                _createVNode(_component_InputText, {
                  placeholder: "Bill No",
                  modelValue: _ctx.item.billNo,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.item.billNo) = $event))
                }, null, 8, ["modelValue"])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_105, [
        _createVNode(_component_Button, {
          class: "p-col p-button-success b-style",
          icon: "pi pi-home",
          label: "HOME",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.redirectHome()))
        }),
        _createElementVNode("span", _hoisted_106, [
          _hoisted_107,
          _hoisted_108,
          _createTextVNode(" # " + _toDisplayString(_ctx.state.savedItemList.length), 1)
        ]),
        _createElementVNode("span", _hoisted_109, [
          _hoisted_110,
          _hoisted_111,
          _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.totalGross)), 1)
        ]),
        _createElementVNode("span", _hoisted_112, [
          _hoisted_113,
          _hoisted_114,
          _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.totalDiscAmount)), 1)
        ]),
        (_ctx.taxNames[0].show)
          ? (_openBlock(), _createElementBlock("span", _hoisted_115, [
              _createTextVNode("Total " + _toDisplayString(_ctx.taxNames[0].taxName) + " ", 1),
              _hoisted_116,
              _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.totalTax1)), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.taxNames[1].show)
          ? (_openBlock(), _createElementBlock("span", _hoisted_117, [
              _createTextVNode("Total " + _toDisplayString(_ctx.taxNames[1].taxName) + " ", 1),
              _hoisted_118,
              _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.totalTax2)), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.taxNames[2].show)
          ? (_openBlock(), _createElementBlock("span", _hoisted_119, [
              _createTextVNode("Total " + _toDisplayString(_ctx.taxNames[2].taxName) + " ", 1),
              _hoisted_120,
              _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.totalTax3)), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_121, [
          _hoisted_122,
          _hoisted_123,
          _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.netTotal)), 1)
        ]),
        _createVNode(_component_Button, {
          class: "p-col p-button-warning b-style",
          icon: "pi pi-arrow-right",
          label: "NEXT",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.openPaymentMethod(!_ctx.v$.$invalid))),
          disabled: _ctx.item.profileID == 0 || _ctx.netTotal <= 0
        }, null, 8, ["disabled"])
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.receiptDailog,
      "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.receiptDailog) = $event)),
      style: { width: '600px' },
      header: "Search Receipt",
      position: "top"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "No",
          icon: "pi pi-times",
          class: "p-button-text",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.refundReceiptDialog = false))
        }),
        _createVNode(_component_Button, {
          label: "Search",
          icon: "pi pi-search",
          class: "p-button-success",
          disabled: _ctx.item.searchReceiptNo == '',
          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.fetchReceiptNo()))
        }, null, 8, ["disabled"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_124, [
          _hoisted_125,
          _createElementVNode("div", _hoisted_126, [
            _hoisted_127,
            _createVNode(_component_InputText, {
              id: "search_receipt",
              autoFocus: "",
              modelValue: _ctx.item.searchReceiptNo,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.item.searchReceiptNo) = $event)),
              placeholder: "e.g PUR-02502100000000"
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.validationPopup,
      "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.validationPopup) = $event)),
      style: { width: '600px' },
      header: "Confirm"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Close",
          icon: "pi pi-close",
          class: "p-button-danger",
          onClick: _ctx.closeValidationPopup
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_128, [
          _hoisted_129,
          _createElementVNode("span", null, _toDisplayString(_ctx.validationPopupMessage), 1)
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_PaymentScreen, {
      receiptDetail: {
      dialogStatus: _ctx.paymentDialog,
      itemSource: _ctx.item.type,
      restriction: 'No',
      paymentOptionType: 'Cashier',
      cashPayment:_ctx.cashPaymentOption,
      cardPayment:_ctx.cardPaymentOption,
      chequePayment:_ctx.chequePaymentOption,
      payLater: _ctx.payLaterOption,
      paySupplierCredit:_ctx.paySupplierCredit,
      dialogTitle: 'Purchase',
      receivedTxt: 'Paid Amount',
      customerID: this.item.profileID,
      customerName: this.state.selectedProfile,
      customerType: this.state.selectedProfileType,
      closeConfirmation: true,
    },
      onClosePaymentScreenEvent: _ctx.closePaymentScreen,
      onGetProceededPaymentsEvent: _ctx.getProceededPayments
    }, null, 8, ["receiptDetail", "onClosePaymentScreenEvent", "onGetProceededPaymentsEvent"]),
    _createVNode(_component_FileUploader, {
      uploaderDetail: {
          status: _ctx.uploaderStatus,
          dialogTitle: 'Upload Purchases CSV file:',
          imageType: '.csv',
        },
      onUpdateUploaderStatus: _ctx.updateUploaderStatus
    }, null, 8, ["uploaderDetail", "onUpdateUploaderStatus"]),
    _createVNode(_component_ProfilerDialog, {
      profilerDetail: {
      status: this.profileStatus,
      profilerID: 0,
      statusType: this.statusType,
      dialogTitle: 'Add New Supplier',
      currentUserID: this.currentUserID,
      profileTypes: this.profileTypes
    },
      onUpdateProfilerStatus: _ctx.updateProfilerStatus
    }, null, 8, ["profilerDetail", "onUpdateProfilerStatus"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.errorDialog,
      "onUpdate:visible": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.errorDialog) = $event)),
      style: { width: '450px' },
      header: "Invalid Data"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Ok",
          icon: "pi pi-check",
          class: "p-button-success",
          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.errorDialog = false))
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_130, [
          _hoisted_131,
          (this.validationErrors.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.validationErrors, (message, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    style: {"font-size":"1rem"}
                  }, _toDisplayString(message), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}